import React, { Component } from "react";
import _ from "lodash" // Import the entire lodash library
import Grid from '@material-ui/core/Grid';
import { reset, Field, reduxForm, change } from 'redux-form';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';


import AppBar from '@material-ui/core/AppBar';
import Box from '@material-ui/core/Box';
import Checkbox from '@material-ui/core/Checkbox';
import Paper from '@material-ui/core/Paper'
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal'
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import SwipeableViews from 'react-swipeable-views';
import {
    renderTextField,
    renderSwitchWithLabel,
} from '../../utils/engageComponents';

import {GetApps, UpdateApp, AddApp} from '../../actions/appsActions';
import { SetHeaderButtons } from '../../actions/headerButtonsActions';
import { IconsModal } from '../scheduler/IconsModal';
import TranslationField from "./TranslationField";


const TabPanel = (props) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}>
            {value === index && (
                <Box p={3}  style={{padding:'0px', margin:'0px'}}>
                    <Grid >{children}</Grid>
                </Box>
            )}
        </div>
    );
};

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};


const validate = (values) => {
    const errors = {};

    const regex = new RegExp('^[0-9]+$');

    if(!values.AppId){
        errors.AppId = 'Please enter an id';
    }else if(!regex.test(values.AppId)){
        errors.AppId = 'Id can only contain numbers';
    }

    // if(!values.IconResourceObject ||  values.IconResourceObject.length === 0){
    //     errors.IconResourceObject = 'please select an option';
    // }

    if (!values.Name) {
        errors.Name = 'Please enter a Name';
    }

    if (!values.DeepLink) {
        errors.DeepLink = 'Please enter deep link';
    }

    // if (!values.appDetailIconUrl) {
    //     errors.appDetailIconUrl = 'Please enter icon url';
    // }

    return errors;
};

class Apps extends Component {
    constructor(props) {
        super(props);
        this.state = {
            communityId: localStorage.getItem('communityId')? localStorage.getItem('communityId') : undefined,
            newAppsData: undefined,

            //App Details
            detailsTab: 0,
            openIconResourceNameSelect: false,
            optionIconsSelected: undefined,
            isAdminAppAppDetails: undefined,
            appNameAppDetails: undefined,
            appIdAppDetails: undefined,
            elementForDetail: undefined,
            isAppActiveForCommunity: undefined,
            shouldUpdate: false,
            openSelectIconModal: false,

            //Translations
            isTranslationEnabled: false,
            translationData:  [{languageCode:'es', fieldLabel:'Nombre'}, {languageCode:'fr', fieldLabel:'Nom'}],
        };
        }

    componentDidMount() {
        this.SetHeaderButtons();
        const communityId = localStorage.getItem('communityId')? localStorage.getItem('communityId') : undefined;

        if(communityId)
            this.props.GetApps(communityId);
    };

    a11yProps = (index) => {
        return {
            id: `full-width-tab-${index}`,
            'aria-controls': `full-width-tabpanel-${index}`,
        };
    };

    //HEADER BUTTONS
    SetHeaderButtons = () => {
        const headerButtons = this.getHeaderButtons();

        this.props.SetHeaderButtons(headerButtons)
    };

    getHeaderButtons = () => {
        
        const styles = {
            globalActions: {
                marginLeft: 'auto',
                marginRight: '0px'
            },
            disabledDeleteButton: {
                backgroundColor: 'white'
            },
            disabledButton: {
                font: '24px',
                border: 'none',
                padding: '10px 15px',
                textAlign: 'center',
                textDecoration: 'none',
                display: 'inline-block',
                margin: '4px 3px',
                boxShadow: '0px 8px 16px #00000066',
                borderRadius: '50px',
                background: '#17d647 0% 0% no-repeat padding-box',
                float: 'right',
                backgroundColor: 'white',
                color: '#686868 ',
                pointerEvents: 'none',
            },
            skyBlueButton: {
                font: '24px',
                border: 'none',
                padding: '10px 15px',
                textAlign: 'center',
                textDecoration: 'none',
                display: 'inline-block',
                margin: '4px 3px',
                cursor: 'pointer',
                boxShadow: '0px 8px 16px #00000066',
                borderRadius: '50px',
                color: '#ffffff',
                background: '#17d647 0% 0% no-repeat padding-box',
                float: 'right',
                backgroundColor: '#009EDD',
            },
        }

        
        return(           
            <Grid container  style={styles.globalActions} >
                <div className="appbtn-list-engage" style={styles.globalActions}> 
                    <div id='add_dining_save_btn' className="blueBottomButon appbtnBarButton" onClick={() => this.newApp()}>
                        Add App
                    </div> 
                </div>
            </Grid>
        )
    }
    newApp = () =>{
        this.setState({openAppDetailModal: true, detailsTab:0, isNewApp: true})
    }


    handleCheckBoxClick = async ( _id) =>{
        if(!_id)
            return false;

        const oldApps = (this.state && this.state.newAppsData)? [...this.state.newAppsData]: [];
        let elementFound = (this.state && this.state.newAppsData)? this.state.newAppsData.find(element => (element._id === _id)) : undefined;

        if(!elementFound || !elementFound.appCommunities)
            return false

        elementFound = {...elementFound};
        const community = elementFound.appCommunities[0]

        if(!community)
            return false;

        community.active = !community.active;

        let appToUpdate = (this.props && this.props.appsData)? this.props.appsData.find( app => app._id === _id): undefined;

        const newApps = oldApps.map(element =>  (element._id === _id)? elementFound : element)

        const switchValue = this.GetSwitchStatus(this.state.newAppsData)
        
        this.setState({newAppsData: newApps, switchAllCommunitiesSelected: switchValue});        

        if(appToUpdate){
            const appCommunities =  (appToUpdate && appToUpdate.appCommunities)? appToUpdate.appCommunities : [];

            const communityFound = (elementFound && elementFound.appCommunities)? elementFound.appCommunities[0]: undefined;

            let communityObject = appCommunities.find( community => community.communityId === communityFound.communityId);

            if(communityObject){
                communityObject = _.cloneDeep(communityObject);
                communityObject.active =  !communityObject.active;
                const newCommunityObject = appCommunities.map(community => community.communityId === communityFound.communityId? communityObject : community);

                appToUpdate.appCommunities = newCommunityObject;

                if(this.props.UpdateApp){
                    await this.props.UpdateApp(appToUpdate._id, appToUpdate);
    
                    if(this.state && this.state.communityId)
                        this.props.GetApps(this.state.communityId);
                }
            }
        }
    };

    GetCheckboxElement = ({element}) =>{

        if(!element)
            return <Grid></Grid>;

        const appCommunities = (element && element.appCommunities  && element.appCommunities.length > 0)? element.appCommunities[0] : undefined;

        if(!appCommunities)
            return <Grid></Grid>;
        

        return(
            <Grid item container justify="center" alignContent="center" >
                <Grid item alignContent="center" justify="center" style={{ display:'flex', alignItems:'center'}}>
                    <Grid item className="EllipsisItem">
                        {(element && element.name)? element.name : ''}
                    </Grid>
                </Grid>
            </Grid>
        )
    };

    onCardClick = (element) =>{
        this.setState((prevState)=>( {openAppDetailModal: !prevState.openAppDetailModal , detailsTab:0, elementForDetail: element}),    
                        this.populateAppDetailsModal(element)
        );

    };

    cleanAppDetailsModal = () =>{
        this.setState({
            openIconResourceNameSelect: false,
            optionIconsSelected: undefined,
            isAdminAppAppDetails: undefined,
            appNameAppDetails: undefined,
            appIdAppDetails: undefined,
            elementForDetail: undefined,
            isTranslationEnabled: false,   
            translationData:  [{languageCode:'es', fieldLabel:'Nombre',}, {languageCode:'fr', fieldLabel:'Nom'}],
        });

        this.props.dispatch(reset('AppsForm'));

    };

    closeModal = () =>{

        this.cleanAppDetailsModal();
        this.setState({ openAppDetailModal: false, elementForDetail: undefined , shouldUpdate: true})
        
    };

    GetIconResourceName = (optionSelected) =>{

        if(!optionSelected && !optionSelected.name)
            return undefined

        const regEx1 = new RegExp('-', "g");           
        const regEx2 = new RegExp(' ', "g");

        let newName = optionSelected.name? optionSelected.name.replace(regEx1,'_').replace(regEx2,'_'): undefined;
        newName = `ic_${newName}`;

        return newName;
    };

    updateApp= async(values, app) =>{
        try{    
            
            const newAppAdminStatus =  (this.state.isAdminAppAppDetails)? this.state.isAdminAppAppDetails : undefined;
            const newAppId =  values.AppId;
            const newAppName = (values && values.Name)? values.Name : undefined;
            const newAppIconResourceName =  (this.state && this.state.optionIconsSelected)?  this.GetIconResourceName(this.state.optionIconsSelected): undefined;
            const newAppIconUrl = (values && values.appDetailIconUrl)? values.appDetailIconUrl :undefined;
            const newAppDeppLink = (values && values.DeepLink)? values.DeepLink :undefined;
    
            
            let appFound = (this.props && this.props.appsData)? this.props.appsData.find(app => app._id === app.newAppId): undefined;
            appFound = {...appFound};

            appFound.adminApp = newAppAdminStatus;
            appFound.appId = newAppId;
            appFound.iconResourceName = newAppIconResourceName;
            appFound.name = newAppName;
            appFound.iconResourceName = newAppIconResourceName;
            appFound.iconUrl = newAppIconUrl;            

            let originalApp = (this.props.appsData) ? this.props.appsData.find(app => app._id === appFound.appId) : undefined;
            originalApp = _.cloneDeep(originalApp);

            let newCommunity = app.appCommunities[0];

            if(!originalApp)
                return
            
            originalApp.appCommunities = originalApp.appCommunities.map(comm => comm.communityId === newCommunity.communityId? newCommunity : comm);

            originalApp.adminApp = newAppAdminStatus;
            originalApp.appId =newAppId;
            originalApp.iconResourceName = newAppIconResourceName;
            originalApp.name =newAppName;
            originalApp.iconUrl = newAppIconUrl;
            originalApp.deepLinK = newAppDeppLink;
            originalApp.translations = (this.state.translationData)? this.state.translationData.map(t =>   ({languageCode: t.languageCode ,name: t.name})): [];

            if(this.props.UpdateApp){
                await this.props.UpdateApp(app._id, originalApp);

                if(this.state && this.state.communityId){
                    await this.props.GetApps(this.state.communityId);
                }
    
                this.closeModal();
            }

        }catch(err){
            return undefined;
        }
    };

    addApp = async(values) =>{

        let appToSave = {};

        const newAppAdminStatus =  (this.state.isAdminAppAppDetails)? this.state.isAdminAppAppDetails : undefined;
        const newAppId = values.AppId;
        const newAppName = (values && values.Name)? values.Name : undefined;
        const newAppIconResourceName =  (this.state && this.state.optionIconsSelected)?  this.GetIconResourceName(this.state.optionIconsSelected): undefined;
        const newAppIconUrl = (values && values.appDetailIconUrl)? values.appDetailIconUrl :undefined;
        const newAppDeppLink = (values && values.DeepLink)? values.DeepLink :undefined;

        appToSave.adminApp = newAppAdminStatus;
        appToSave.appId = newAppId;
        appToSave.name = newAppName;
        appToSave.iconUrl = newAppIconUrl;
        appToSave.iconResourceName = newAppIconResourceName;
        appToSave.deepLink = newAppDeppLink;
        appToSave.userUpdate= 'superUser'
        appToSave.translations = (this.state.translationData)? this.state.translationData.map(t =>   ({languageCode: t.languageCode ,name: t.name})): [];

        if(
            !appToSave ||
            !appToSave.appId ||
            !appToSave.name ||
            !appToSave.deepLink||
            !appToSave.iconUrl ||
            !appToSave.iconResourceName ||
            !appToSave.userUpdate 
        )
            return
        
        await this.props.AddApp(appToSave);
        
        if(this.state && this.state.communityId)
            this.props.GetApps(this.state.communityId);

        this.closeModal();
    };

    onSubmitHandler = (values) =>{
        if(this.state.elementForDetail && this.state.elementForDetail._id){
            this.updateApp(values, this.state.elementForDetail);
        }else{
            this.addApp(values)
        }
            
    }

    populateAppDetailsModal = (element) =>{
        if(!element)
            return

        if(element.adminApp)
            this.setState((prevState)=>( {isAdminAppAppDetails: element.adminApp }));

        if(element.appId){
            this.props.dispatch(change('AppsForm', 'AppId', element.appId));
            this.setState((prevState)=>( {appIdAppDetails: element.appId}));
        }

        if(element.name)
            this.props.dispatch(change('AppsForm', 'Name', element.name));

        if(element.deepLinK)
            this.props.dispatch(change('AppsForm', 'DeepLink', element.deepLinK));
        
        if(element.iconResourceName && element.iconUrl){
            const iconFound = (this.props && this.props.IconsData)? this.props.IconsData.find(el => el.iconUrl === element.iconUrl) : undefined;

            if(!iconFound)
                return      
            
            this.setState((prevState)=>( {optionIconsSelected: {...iconFound,  categoryColor:'#949494'}}));
            
            this.props.dispatch(change('AppsForm', 'IconResourceObject', iconFound.name));            
            this.props.dispatch(change('AppsForm', 'appDetailIconUrl', iconFound.iconUrl));            
        }

        if(element && element.translations && element.translations.length > 0){
            const translationsWithData =element.translations.some(t => (t.name && t.name.length > 0))
    
            if(translationsWithData)
                this.setState({isTranslationEnabled: true, translationData: element.translations})       
        }
    };

    ElementComponent = ({element, isResident = false}) =>{
        if(!element)
            return undefined;
        
        const styles ={
            element:{
                padding:'10px',
            },
            card:{
                borderRadius:'16px',
                backgroundColor: "#92949c",
                minHeight:'150px'
            },
            image:{
                width:'60px',
                height:'60px',
            },
            content:{
                height:'60%',
                padding:'10px'
            },
            checkBox:{
                padding:'10px',
                height:'40%',
                backgroundColor:'#000000',
                borderBottomLeftRadius:'16px',
                borderBottomRightRadius:'16px'
            }
        }

        return(
            <Grid item container>
                <Grid item container style={styles.element}>
                    <Grid item container 
                        justify="center" 
                        alignContent="center" 
                        style={styles.card} 
                        onClick={() => this.onCardClick(element)}
                    >
                        
                        <Grid item style={styles.content} >
                            {
                                (element.iconUrl)?
                                <Grid item container style={styles.image}>
                                    <img src={element.iconUrl} alt={`${element.name}`} style={styles.image}/>
                                </Grid>
                                :
                                this.GetElementBadge(element)
                            }
                        </Grid>
                        <Grid item container style={styles.checkBox}>
                            <Grid item container justify="center" alignContent="center">
                                <this.GetCheckboxElement element={element}/>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        )
    };

    GetElementBadge = (element) =>{
        const styles={
            container:{
                padding:'10px'
            },
            badge:{
                width:'60px',
                height:'60px',
                borderRadius: '50%',
                backgroundColor: "#92949c",
                fontSize:'25px'
            }
        }

        const initials = (element && element.name)? element.name.split(' ').map( word => word[0].toUpperCase()) : '';

        return(
            <Grid item container justify='center' alignContent="center" style={styles.badge}>
                <Grid item >
                    {initials}
                </Grid>
            </Grid>
        )
    };

    handlerToggleAllCommunities = () =>{

        const newSwitchStatus = (this.state && this.state.switchAllCommunitiesSelected)? !this.state.newAppsData :  true; 
        this.setState((prevState)=>({switchAllCommunitiesSelected: !prevState.switchAllCommunitiesSelected}));
        
        const oldApps = (this.state && this.state.newAppsData)? [...this.state.newAppsData]: [];

        let newApps = [];
        for(let i =0; i< oldApps.length; i++){
            const currentApp = {...oldApps[i]};

            currentApp.appCommunities[0].active = newSwitchStatus;

            newApps.push(currentApp);
        }

        this.setState({newAppsData: newApps})
    };

    GetSwitchStatus = (newAppsData) =>{

        if(!newAppsData)
        return false;
        
        let initialSwitchValue = true;

        for(let i=0; i< newAppsData.length; i++){
            const currentApp = newAppsData[i];

            const appCommunities = (currentApp && currentApp.appCommunities && currentApp.appCommunities.length > 0)? currentApp.appCommunities[0]: undefined;

            if(!appCommunities)
                break;

            initialSwitchValue = appCommunities.active;

            if(!initialSwitchValue)
                break;
        }

        return initialSwitchValue;
    }

    IconResourceNameComponentOnChangeHandler = (e,newItem) =>{
        this.setState({ optionIconsSelected: {...newItem,  categoryColor:'#949494'} });
        
        this.props.dispatch(change('AppsForm', 'IconResourceObject', newItem));
        this.handleCategoryCombo(null, false);
    };

    handleCategoryCombo = (e, option) => {
        if (!option) {
            this.setState((prevState) => ({ openIconResourceNameSelect: !prevState.openIconResourceNameSelect }));
        } else {
            this.setState({ openIconResourceNameSelect: option });
        }
    }

    onBlurIconResourceNameComponentHandler = () =>{
        this.setState({ openIconResourceNameSelect: false });
    }

    appDetailsAdminSwitch = (status = undefined)  =>{

        if((status && status === 'false') || status === 'true'){
            this.setState({isAdminAppAppDetails: status});        
        } else{
            this.setState((prevState) => ({isAdminAppAppDetails: !prevState.isAdminAppAppDetails}));        
        }
    }

    onAppIdChange = (e) =>{
        if(!e || !e.target || !e.target.value || e.target.value === ''){
            this.setState({appIdAppDetails: undefined});    
            return
        }
    
        const regex = new RegExp('^[0-9]+$');
        let newValue = e.target.value;

        if(regex.test(newValue) && this.state && this.state.appIdAppDetails && this.state.appIdAppDetails.length > 0){
            newValue= this.state.appIdAppDetails;
        } else{
            newValue = ''; 
        }

        this.setState({appIdAppDetails: newValue});    
        //this.props.dispatch(change('AppsForm', 'AppId', newValue));
    };

    onDragEnd(result) {
        // dropped outside the list
        if (!result.destination) {
          return;
        }
    
        const items = this.reorder(
          this.state.items,
          result.source.index,
          result.destination.index
        );
    
        this.setState({
          items,
    });
}

 reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
  
    return result;
  };

  
   getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",
    padding: 8 * 2,
    margin: `0 0 ${8}px 0`,
  
    // change background colour if dragging
    background: isDragging ? "lightgreen" : "grey",
  
    // styles we need to apply on draggables
    ...draggableStyle
  });
  
   getListStyle = isDraggingOver => ({
    background: isDraggingOver ? "lightblue" : "lightgrey",
    padding: 8,
    width: 250
  });

    handleTabChange = (e, step) => {
        this.setState({ detailsTab: step })
    };

    
    handleChangeIndex = (step) => {
        //this.setState({ detailsTab: step })
    };


    GetResidentCard = ({resident}) =>{

        const styles ={
            element:{
                padding:'10px',
            },
            card:{
                borderRadius:'16px',
                backgroundColor: "#92949c",
                minHeight:'150px',
                color: '#686868'
            },
            image:{
                width:'60px',
                height:'60px',
            },
            content:{
                height:'60%',
                padding:'10px'
            },
            checkBox:{
                padding:'10px',
                height:'40%',
                backgroundColor:'#000000',
                borderBottomLeftRadius:'16px',
                borderBottomRightRadius:'16px',
                fontSize:'12px'
            }
        }

        try{
            if(!resident) return <Grid item container></Grid>

            const residentFullData = this.props.residentData.find(res => res._id === resident._id)

            return(
                <Grid item container>
                    <Grid item container style={styles.element}>
                        <Grid item container 
                            justify="center" 
                            alignContent="center" 
                            style={styles.card} 
                        >                           
                            <Grid item style={styles.content} >
                                {
                                    (residentFullData.pictureUrl)?
                                    <Grid item container style={styles.image}>
                                        <img src={residentFullData.pictureUrl} alt={`${residentFullData.firstName +' '+ residentFullData.lastName}`} style={{...styles.image, borderRadius:'50%'}}/>
                                    </Grid>
                                    :
                                    this.GetElementBadge({name: residentFullData.firstName +' '+ residentFullData.lastName})
                                }
                            </Grid>
                            <Grid item container style={styles.checkBox}>
                                <Grid item container justify="center" alignContent="center">
                                    <this.GetResidentCheckBox resident={residentFullData} isActive={resident.active? resident.active: false }/>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            )
        }catch(err){}
    };

    GetResidentCheckBox = ({resident = undefined, isActive = false}) =>{
        
        try{
            if(!resident) return <Grid item container ></Grid>

            return (
                <Grid item container justify="center" alignContent="center">
                <Grid item style={{width:'30%',}} onClick={(e) => e.stopPropagation()}>
                    <Checkbox
                        id={`checkbox_${resident._id}`}
                        checked={isActive}
                        onChange={(e) => this.residentClickHandler(resident._id)}
                        name={`checkBox_${resident._id}`}
                        className={isActive? 'isChecked' : ''}
                    />
                </Grid>
                <Grid item alignContent="center" justify="flex-start" style={{ display:'flex', alignItems:'center', width:'70%'}}>
                    <Grid item style={{textOverflow: 'ellipsis', whiteSpace:'nowrap', overflow:'hidden', paddingLeft:'5px'}}>
                        {(resident.firstName)? resident.firstName +' '+ resident.lastName : ''}
                    </Grid>
                </Grid>
            </Grid>
            )
        }catch(err){
            return <Grid item container ></Grid>
        }
    };

    residentClickHandler = (residentId) =>{
        try{
            if(!residentId || !this.state.elementForDetail || !this.state.elementForDetail.appCommunities[0] || !!this.state.elementForDetail.appCommunities[0].appResident) return undefined;


            let element = _.cloneDeep(this.state.elementForDetail);
            let appResidents = element.appCommunities[0].appResidents;
            let residentFound = appResidents.find( res => res._id === residentId);
            residentFound.active = !residentFound.active;

            appResidents = appResidents.map(res => res._id === residentId? residentFound: res);
            
            let newElement = _.cloneDeep(this.state.elementForDetail);
            newElement.appCommunities[0].appResidents = appResidents;

            this.setState({elementForDetail: newElement})

        }catch(err){
            return undefined
        }
    };

    handleSelectIcon = (iconSelected) =>{
        if(!iconSelected) return undefined;

        this.props.dispatch(change('AppsForm', 'IconResourceObject', iconSelected.name));
        this.props.dispatch(change('AppsForm', 'detailIconUrl', (iconSelected && iconSelected.iconUrl)? iconSelected.iconUrl : '') );

        this.setState({optionIconsSelected: iconSelected, openSelectIconModal: false})
    }

    onAddTranslationSwitch = (status = undefined) =>{
        
        if((status && status === 'false') || status === 'true'){
            this.setState((prevState) => ({isTranslationEnabled: status}));        
        } else{
            this.setState((prevState) => ({isTranslationEnabled: !prevState.isTranslationEnabled}));        
        }
    }

    onChangeHandler = (obj) =>{

        if(!obj && !obj.languageCode) return undefined;

        const translationData = this.state.translationData? this.state.translationData: [];
        let objFound = translationData.find(trasnlation => trasnlation.languageCode === obj.languageCode);

        let newTranslationData = [];
        if(!objFound){
            objFound.languageCode = obj.languageCode
            objFound.name = obj.value

            newTranslationData = [...translationData, objFound];
        } else{
            objFound.name = obj.value;
            newTranslationData = translationData.map(t => t.languageCode === obj.languageCode? objFound: t);
        }

        this.setState({translationData: newTranslationData});        
    }

    render(){
        const Height = 650;
        const { handleSubmit } = this.props;

        if(this.state && this.state.optionIconsSelected){
            this.props.dispatch(change('AppsForm', 'appDetailIconUrl', this.state.optionIconsSelected.iconUrl));            
        };



        const styles={
            container:{
                backgroundColor:'#1f1f1f',
                borderRadius:'16px',
                minHeight:'50px',
            },
            paperModal: {
                backgroundColor: '#1F1F1F',
                padding: '6px',
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%,-50%)',
                width: '45%',
                height: Height+'px',

            },
            buttonStyle: {
                borderRadius: '25px',
                backgroundColor: '#959494',
                width: '9rem',
                fontSize: '1rem',
                fontWeight: 'bold',
                color: 'white',
                textAlign: 'center',
                textTransform: 'none'
            },
            tabStyles:{
                backgroundColor: '#1f1f1f',
                borderTopLeftRadius: '16px',
                borderTopRightRadius: '16px',
                color: 'white',
                fontFamily: 'Gotham-Bold',
                fontSize: '16px',
                textTransform: 'none',    
            },        
            SelectedTabStyle: {
                backgroundColor: '#454446',
                borderTopLeftRadius: '16px',
                borderTopRightRadius: '16px',
                color: 'white',
                fontFamily: 'Gotham-Bold',
                fontSize: '16px',
                textTransform: 'none',    
            }
        };

        if((this.props && this.props.newAppsData && this.props.newAppsData.length > 0 && !this.state.newAppsData) || this.state.shouldUpdate){    
            const initialSwitchValue = this.GetSwitchStatus(this.props.newAppsData);
            this.setState({newAppsData: this.props.newAppsData,switchAllCommunitiesSelected: initialSwitchValue, shouldUpdate:false})
        };

        return(
            <Grid container style={styles.container}>
                <form style={{width:'100%', height:'100%', display:'flex'}}>
                <Grid item container justify="center" alignContent="center" style={{heigth:'100%'}}>
                {
                    (this.props && this.props.newAppsData && this.props.newAppsData.length)?
                    <Grid item container justify="center" alignContent="center"  style={{}}>
                        <Grid item container>                        
                        {
                            this.props.newAppsData.map( (element, index) =>(
                            <Grid item container xs={6} md={4} lg={3} key={`${element._id}_element`}>
                                <this.ElementComponent key={element._id} element={element}/>           
                            </Grid>
                        ))
                        }
                        </Grid>
                    </Grid>
                    :
                    <Grid item container justify="center" alignContent="center" style={{heigth:'100%'}}> 
                        <Grid item style={{}}> No information found!</Grid>
                    </Grid>
                }             
                </Grid>
                {
                    (this.state && this.state.openAppDetailModal)?
                    <Modal
                        open={this.state.openAppDetailModal}
                        onClose={this.closeModal}
                        aria-labelledby="simple-modal-title"
                        aria-describedby="simple-modal-description"
                    >
                        <Paper className='modalPaperStyles' elevation={3} style={{ ...styles.paperModal }} color='secondary'>
                            <Grid container style={{ height: (Height)+'px',}}>                                
                                <Grid item container className='TitleRepairsModal' alignContent='center' justify='flex-start' style={{ height: (Height*.15)+'px' , padding:'0px', margin:'0px'}}>
                                    <Grid item  style={{ height:'100%'}} >
                                        App Details
                                    </Grid>
                                </Grid>
                                <Grid item container  alignContent='flex-start' justify='center' style={{ height: (Height*.1)+'px', fontSize: '12px' }}>
                                    {
                                        (this.state.elementForDetail && this.state.elementForDetail._id)?
                                        <AppBar position="static" color="default" elevation={0} style={{ backgroundColor: '#2a2a2b' }}>
                                            <Tabs
                                                value={this.state.detailsTab}
                                                onChange={this.handleTabChange}
                                                TabIndicatorProps={{ style: { backgroundColor: 'transparent' } }}
                                                variant="fullWidth"
                                                aria-label="full width tabs community"
                                            >
                                                <Tab className='setupInfoSection' label="Details"           style={(this.state.detailsTab === 0) ? styles.SelectedTabStyle : styles.tabStyles} {...this.a11yProps(0)} disableRipple={true} disableFocusRipple={true}/>
                                                <Tab className='setupInfoSection' label="Enabled Residents"  style={(this.state.detailsTab === 1) ? styles.SelectedTabStyle : styles.tabStyles} {...this.a11yProps(1)} disableRipple={true} disableFocusRipple={true}/>
                                                <Tab className='setupInfoSection' label="Disabled Residents" style={(this.state.detailsTab === 2) ? styles.SelectedTabStyle : styles.tabStyles} {...this.a11yProps(2)} disableRipple={true} disableFocusRipple={true}/>
                                            </Tabs>
                                        </AppBar>
                                        :
                                        <Grid item container></Grid>
                                    }
                                </Grid>
                                {/* TABS Content */}
                                <Grid item container  alignContent='flex-start' justify='center' style={{ height: (Height*.6)+'px', fontSize: '12px',  overflow:'auto'}}>
                                    <SwipeableViews
                                        axis={'x' === 'rtl' ? 'x-reverse' : 'x'}
                                        index={this.state.detailsTab}
                                        onChangeIndex={this.handleChangeIndex}
                                        style={{ width: '100%',height: (Height*.6)+'px'}}
                                    >
                                        <TabPanel value = {this.state.detailsTab} index={0} dir={'x'} >
                                            <Grid item container style={{padding:'25px 50px'}} justify="center" alignContent="center">
                                                <Grid item container justify="flex-start" alignContent="center">
                                                    <Grid item xs={12} md={8} lg={6}  style={{fontSize:'25px', color:'#949494'}}>
                                                        <Field 
                                                            idToSet='adminDetailsAdminAppSwitch'
                                                            name='adminDetailsAdminAppSwitch'
                                                            label={'Admin App'}
                                                            checked={this.state.isAdminAppAppDetails? this.state.isAdminAppAppDetails : false}
                                                            onClick={this.appDetailsAdminSwitch}
                                                            component={renderSwitchWithLabel}
                                                            labelInLeft={false}
                                                            stylesLabel={{}}
                                                        />
                                                    </Grid>
                                                </Grid>
                                                <Grid item container justify="flex-start" alignContent="center">
                                                    <Grid item xs={12} md={8} lg={6}  style={{fontSize:'25px', color:'#949494', padding:'5px 0'}}>
                                                        <Field 
                                                            idToSet='addTranslationsSwitch'
                                                            name='addTranslationsSwitch'
                                                            label={'Add translations'}
                                                            checked={this.state.isTranslationEnabled? this.state.isTranslationEnabled : false}
                                                            onClick={this.onAddTranslationSwitch}
                                                            component={renderSwitchWithLabel}
                                                            labelInLeft={false}
                                                            stylesLabel={{}}
                                                        />
                                                    </Grid>
                                                </Grid>
                                                {
                                                    (this.state.isTranslationEnabled)? 
                                                    <TranslationField  inputData ={this.state.translationData? this.state.translationData : []} onChangeHandler={this.onChangeHandler}/>
                                                    :
                                                    <Grid item container></Grid>
                                                }
                                                <Grid item container style={{width:'100%'}}>
                                                    <Field
                                                        name="AppId"
                                                        label="App Id"
                                                        maxLength={20}
                                                        valueToSet = {(this.state.appIdAppDetails && this.state.appIdAppDetails > 0)? this.state.appIdAppDetails : ''}
                                                        //onChange={this.onAppIdChange}
                                                        component={renderTextField}
                                                    />
                                                </Grid>
                                                <Grid item container style={{width:'100%'}}>
                                                    <Field
                                                        name="DeepLink"
                                                        label="Deep Link"
                                                        maxLength={20}
                                                        component={renderTextField}
                                                    />
                                                </Grid>
                                                <Grid item container style={{width:'100%'}}>
                                                    <Field
                                                        name="Name"
                                                        label="Name"
                                                        maxLength={20}
                                                        component={renderTextField}
                                                    />
                                                </Grid>
                                            
                                                <Grid item container style={{width:'100%'}}>
                                                    <Grid item container xs={12} md={6} lg={8}>
                                                        <Field
                                                            name="IconResourceObject"
                                                            label="Icon Resourse Name"
                                                            maxLength={20}
                                                            component={renderTextField}
                                                            disabled={true}
                                                        />
                                                    </Grid>
                                                    <Grid item container xs={12} md={6} lg={4} alignContent='center' justify="center">
                                                        <Grid item >
                                                            <Button id='appDetails_save_btn' style={{ ...styles.buttonStyle, backgroundColor: '#009edd' ,margin:'10px 10px'}}  onClick={() => this.setState({openSelectIconModal: true}) }>
                                                                {'Select Icon'} 
                                                            </Button>
                                                        </Grid>
                                                    </Grid>
                                                    {/* <Field
                                                        idToSet="IconResourceObject"
                                                        name="IconResourceObject"
                                                        label="Icon Resource Name"
                                                        maxLength={20}
                                                        selected={this.state.optionIconsSelected? this.state.optionIconsSelected : { name: '' }}
                                                        onChangeHandler={(event, newItem) => this.IconResourceNameComponentOnChangeHandler(event,newItem)}
                                                        optionsItemsIconsData={this.props.IconsData? this.props.IconsData : []}
                                                        open={this.state.openIconResourceNameSelect? this.state.openIconResourceNameSelect : false}
                                                        onClick={this.handleCategoryCombo}
                                                        onBlur={this.onBlurIconResourceNameComponentHandler}
                                                        component={renderThumbnailSelect}
                                                    /> */}
                                                </Grid>
                                                {
                                                    (this.state && this.state.optionIconsSelected && this.state.optionIconsSelected.name.length > 0)?
                                                    <Grid item container style={{width:'100%'}}>
                                                        <Field
                                                            name="appDetailIconUrl"
                                                            label="Icon Url"
                                                            maxLength={20}
                                                            disabled={true}
                                                            component={renderTextField}
                                                        />
                                                    </Grid>
                                                    :
                                                    <Grid item></Grid>
                                                }
                                            </Grid>
                                        </TabPanel>
                                        <TabPanel value = {this.state.detailsTab} index={1} dir={'x'} >
                                            <Grid item container style={{padding:'25px 50px'}} justify="flex-start" alignContent="center">
                                            {
                                                (
                                                    this.state.elementForDetail && 
                                                    this.state.elementForDetail.appCommunities && 
                                                    this.state.elementForDetail.appCommunities[0] && 
                                                    this.state.elementForDetail.appCommunities[0].appResidents &&
                                                    this.state.elementForDetail.appCommunities[0].appResidents.filter(res => this.props.residentDataArray.includes(res._id) && res.active).length > 0 
                                                )?
                                                this.state.elementForDetail.appCommunities[0].appResidents.filter(res => this.props.residentDataArray.includes(res._id) && res.active).map(resident => (
                                                    <Grid item container xs={12} md={6} lg ={4}>
                                                        <this.GetResidentCard resident={resident}/>
                                                    </Grid>
                                                ))
                                                :
                                                <Grid item container alignContent="center" justify="center" style={{ color: '#686868 ', fontSize:'18px', paddingTop:'25px'}}>No Residents Enabled</Grid>
                                            }
                                            </Grid>
                                        </TabPanel>
                                        <TabPanel value = {this.state.detailsTab} index={2} dir={'x'} >
                                            <Grid item container style={{padding:'25px 50px'}} justify="flex-start" alignContent="center">
                                            {
                                                (
                                                    this.state.elementForDetail && 
                                                    this.state.elementForDetail.appCommunities && 
                                                    this.state.elementForDetail.appCommunities[0] && 
                                                    this.state.elementForDetail.appCommunities[0].appResidents &&
                                                    this.state.elementForDetail.appCommunities[0].appResidents.filter(res => this.props.residentDataArray.includes(res._id) && !res.active).length > 0
                                                )?
                                                this.state.elementForDetail.appCommunities[0].appResidents.filter(res => this.props.residentDataArray.includes(res._id) && !res.active).map(resident => (
                                                    <Grid item container  xs={12} md={6} lg ={4}>
                                                        <this.GetResidentCard resident={resident}/>
                                                    </Grid>
                                                ))
                                                :
                                                <Grid item container alignContent="center" justify="center" style={{ color: '#686868 ', fontSize:'18px', paddingTop:'25px'}}>No Residents Disabled!</Grid>
                                            }
                                            </Grid>
                                        </TabPanel>
                                    </SwipeableViews> 
                                </Grid>
                                
                                <Grid item container justify='flex-end' alignContent='center' style={{height:((Height*.15))+'px', }}>
                                    <Grid item style={{display:'fex', marginTop:'auto', marginBottom:'auto'}}>
                                        <Button id='appDetails_cancel_btn' style={{ ...styles.buttonStyle,margin:'0 10px'  }} onClick={() => this.closeModal()}>
                                            Cancel
                                        </Button>
                                    </Grid>
                                    <Grid item style={{display:'fex', marginTop:'auto', marginBottom:'auto'}}>
                                        <Button id='appDetails_save_btn' style={{ ...styles.buttonStyle, backgroundColor: '#009edd' ,margin:'0 10px' ,}}  onClick={handleSubmit(this.onSubmitHandler.bind(this))} >                                            {
                                                (this.state && this.state.elementForDetail && this.state.elementForDetail._id)? 'Save' : 'Add'
                                            }
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>                
                        </Paper>
                    </Modal>
                    :
                    <Grid></Grid>
                }
                 {
                        this.state.openSelectIconModal === true ?

                            <IconsModal
                                icons={this.props.IconsData}
                                onSelectIcon={this.handleSelectIcon}
                                iconSelected={this.state.optionIconsSelected}
                                onClose={() => { this.setState({ openSelectIconModal: false }) }}
                            />
                            :
                            undefined
                    }
                </form>
            </Grid>
        )
    }
}

function mapStateToProps(state, ownProps) {

    const communityId = localStorage.getItem('communityId') ? localStorage.getItem('communityId') : undefined;
    let appsData = (state.appsReducer && state.appsReducer.appsData) ? [...state.appsReducer.appsData] : [];
    const IconsData = (state.categoryReducer && state.categoryReducer.IconsData) ? state.categoryReducer.IconsData : [];
    let residentData = (state.residentReducer && state.residentReducer.residentData) ? state.residentReducer.residentData : [];
    let residentDataArray = residentData.map(res => res._id);


    let ArrayData = _.cloneDeep(appsData);
    let newAppsData = [];

    for(let i=0; i< ArrayData.length; i++){
        let app = ArrayData[i];
        let appCommunities = app.appCommunities;

        if(appCommunities){
            appCommunities = appCommunities.filter(community => community.communityId === communityId);
        }

        app.order = undefined;
        app.appCommunities = appCommunities;
        if(appCommunities && appCommunities[0] && appCommunities[0].appOrder){
            app.order = appCommunities[0].appOrder;
        }
        
        //app.appCommunities = [];

        newAppsData.push(app);
    }

    newAppsData = newAppsData.sort( (a,b) => a.order > b.order);  

    return {
        appsData: appsData,
        newAppsData: newAppsData,
        IconsData: IconsData,
        residentData: residentData,
        residentDataArray: residentDataArray,
    };
}

export default connect(mapStateToProps, {GetApps, UpdateApp, AddApp, SetHeaderButtons,})(reduxForm({
    form: 'AppsForm',
    validate,
    enableReinitialize: true,
})(Apps));
